import { connect } from 'react-redux';
import APIAccessSettings from './APIAccessSettings';
import {
  loadAPIAccess,
  createAPIAccess,
  deleteAPIAccess,
  updateAPIAccess,
} from '../../../../redux/actions/APIAccess';

const mapStateToProps = (state) => {
  return {
    APIAccessData: state.APIAccess.APIAccessData,
    status: state.APIAccess.APIAccessStatus,
    subscriptionInfo: state.user.user?.subscription_info,
  };
};

const mapDispatchToProps = {
  loadAPIAccess,
  createAPIAccess,
  deleteAPIAccess,
  updateAPIAccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(APIAccessSettings);
